import { Pin } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "../ui/tooltip";

type PinnedIndicatorProps = {
  isPinned: boolean;
  itemId: string;
  onTogglePin?: (id: string) => void;
};

export const PinnedIndicator = ({ isPinned, itemId, onTogglePin }: PinnedIndicatorProps) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (onTogglePin) {
      onTogglePin(itemId);
    }
  };

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div
          className="flex h-5 w-5 shrink-0 cursor-pointer items-center justify-center rounded-md"
          onClick={handleClick}
        >
          <Pin
            className={`transition-colors ${
              isPinned ? "fill-primary-700 text-primary-700" : "fill-slate-300 text-slate-300"
            }`}
            size={14}
          />
        </div>
      </TooltipTrigger>
      <TooltipContent>{isPinned ? "Unpin" : "Pin"}</TooltipContent>
    </Tooltip>
  );
};
